/*
 * @Autor: Nehc
 * @Date: 2020-12-11 15:12:34
 * @LastEditors: Nehc
 * @LastEditTime: 2020-12-11 15:15:45
 */
import FieldMap from './field_map.vue';

export default FieldMap;
